import { ConsoleLogger, HttpService, Query, QueryHandler, TaggedUrl, Tags, transformDTODate } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';
import { Transform } from 'class-transformer';

export interface KsefSentDocumentErrorsQueryParams {
    documentId: number;
}

export type KsefSentDocumentErrorItem = KsefSentDocumentErrorItemDTO;

class KsefSentDocumentErrorItemDTO {
    @Transform(transformDTODate, { toClassOnly: true }) public readonly date: Date;
    public kinds: 'DocumentValidation' | 'Error' | 'ErrorDuplicateDocument';
    public payload: string;
    public errorCode?: string;
}

export class KsefSentDocumentErrorsQuery extends Query<KsefSentDocumentErrorItem[] | undefined> {
    public constructor(public readonly params: KsefSentDocumentErrorsQueryParams) {
        super();
    }
}

export class KsefSentDocumentErrorsQueryHandlerBase implements QueryHandler<KsefSentDocumentErrorsQuery> {
    private static Url = TaggedUrl.join('eInvoices/:id/errors', [Tags.Api]);

    private readonly logger = new ConsoleLogger(this.constructor.name);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync({ params }: KsefSentDocumentErrorsQuery): Promise<KsefSentDocumentErrorItem[] | undefined> {
        try {
            const url = fillPlaceholders(KsefSentDocumentErrorsQueryHandlerBase.Url, { id: params.documentId });
            const { data } = await this.http.get<KsefSentDocumentErrorItem[]>(url, {dto: KsefSentDocumentErrorItemDTO});
            return data;
        } catch (err) {
            this.logger.error(err);
        }

        return undefined;
    }
}
